import { breakpointQueries as e } from "./constants/breakpoint-queries.mjs";
import { getCurrentBreakpoints as t } from "./utils/get-current-breakpoints.mjs";
import { useEffect as n, useState as r } from "react";
//#region src/hooks/use-media-query/use-media-query.ts
var i = (i) => {
	let a = i ?? t(), [o, s] = r(() => a);
	return n(() => {
		let n = t();
		s(n);
		let r = Object.entries(e).map(([e, t]) => {
			let n = window.matchMedia(t), r = (t) => s((n) => ({
				...n,
				[e]: t.matches
			}));
			return n.addEventListener("change", r), {
				mediaQuery: n,
				handler: r
			};
		});
		return () => r.forEach(({ mediaQuery: e, handler: t }) => e.removeEventListener("change", t));
	}, []), { ...o };
};
//#endregion
export { i as useMediaQuery };
